import loaderModel from 'models/loader-model';
import appModel from 'models/app-model';
import router from 'uav-router';
import {whiteLabelAccount} from 'util/data/env';
import accountManager from 'managers/account-manager';

const SPACE = '\u00A0';

const Loader = {
    view: () => {
        const noAcctYet = !router.params || !router.params.projectId;
        return <div
            class={`loader ${loaderModel.loading ? 'loading' : 'hidden'} ${loaderModel.fade ? 'fade' : ''} ${noAcctYet || appModel.project.isMetaProject ? 'dark-theme' : 'light-theme'}`}>
            <div class="loader-inner">
                {whiteLabelAccount || accountManager.isWhiteLabelAccount ? <div><img src='https://static.unearthlabs.com/oygPKKXaqvhi8k9iwSvY'/></div> : <i class="icon-unearth"></i>}
                <span class={`loading-message${loaderModel.message ? ' visible' : ''}`}>{loaderModel.message || SPACE}</span>
            </div>
        </div>;
    }
};

export default Loader;
